// ProfileChartjs.js
import { useState, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import 'chartjs-adapter-moment'

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
)
/**
 * 
 * @param {Array<string>} targets identifies the out_data keys used in this chart.
 * @param {JSON} out_data object containing time series data keyed by swmm object names.
 * @param {string} outputSection name of the 
 * @returns {JSX} Chart.js Line chart for displaying time-based results from a swmm .out file.
 */
export function ProfileChartjs({out_data, targets, model, titleText=''}) {  
  const [datasets, setDatasets] = useState([])

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip:{
        yAlign: 'bottom'
      },
      legend: {
        display: false
      },
      title: {
        display: titleText.length?true:false,
        text: titleText
      },
    },
    scales: {
      y: {
        position: 'left',
        reverse: false
      },
      x:{
        type: 'linear',
        display: true
      },
    },
  }

  useEffect(()=>{
    let keysAll = out_data?Object.keys(out_data):[]
    if(out_data && targets !== undefined ) {
      let allLabels = {}
      let labelData = []
      let maxObjs = 1000
      let rS1 = []

      // Create the datasets object.
      if(keysAll?.length > 0 && targets !== undefined ) {
        let datasets_maker = []
        // For each target in targets, create a data array if it exists in out_data
        targets.forEach((target, index) => {
          if(target in out_data){
            labelData = []
            rS1[target] = []
            let keys = out_data[target]
            let keysLength = keys.length
            let falseStep = keysLength/maxObjs 

            if(falseStep < 1) falseStep = 1
            for(let i = 0; i < keysLength; i=i+Math.ceil(falseStep)){
              rS1[target].push(out_data[target][i].Value)

              let startTime = out_data[target][i].DateTime
              labelData.push(startTime)
            }

            //allLabels[target+'_x'] = labelData
            allLabels[target+'_x'] = out_data[target].map((value, index) => ({ x: value.DateTime, y: value.Value }))

            datasets_maker.push({
              label: target,
              yAxisID: 'y',
              //xAxisID: [target+'_x'],
              data: allLabels[target+'_x'],//rS1[target],
              backgroundColor: target==='grnd'?'rgba(0, 250, 0, 1)':'white',
              borderColor: target==='grnd'?'rgba(0, 250, 0, 1)':target==='water'?'rgba(0, 0, 250, 1)':'white',
              pointRadius: 0,
              borderWidth: 2,
              pointHitRadius: 20,
            })
          }
        })
        
        setDatasets(datasets_maker)
      }
    }
  },[out_data, targets])

  const data = {
    //labels: labels,
    datasets: datasets
  }

  return (
    <Line options={options} data={data} />
  )
}
